module.exports = __webpack_public_path__ + "static/media/1001006HG.26d02dee.jpg";